import api from "services/api";

/** Spec da campanha de contributários (29/09) §3. SEM_REGISTRO só existe na leitura e conta como Em operação. */
export type LifecycleState = "EM_IMPLANTACAO" | "EM_OPERACAO" | "SEM_REGISTRO";
export type CampaignTypeStateValue = "OFF" | "ARMED" | "ACTIVE";
export type CampaignTypeKey = "contributario";

export interface IContractLifecycle {
  state: LifecycleState;
  milestoneAt: string | null;
  transitions: { state: "EM_IMPLANTACAO" | "EM_OPERACAO"; changedAt: string }[];
  campaignTypes: { type: CampaignTypeKey; state: CampaignTypeStateValue; consentSince: string | null }[];
  permissions: { canConclude: boolean; canReopen: boolean };
}

export interface IConclusionCheck {
  initialLoad: { rows: number } | null;
  pendingMovements: number | null;
  armedCampaigns: { type: CampaignTypeKey; wouldHoldTonight: number | null }[];
  /** Tipos elegíveis com a campanha desligada: ligados depois da conclusão, começam na mesma noite, sem período Armado. */
  eligibleOffTypes: CampaignTypeKey[];
  /** Titulares vivos sem nenhuma decisão de optante. null: contrato não é compulsório com contribuição. ran: a rotina de optantes registrou rodada (âncora); count null: sem âncora ou leitura falhou. */
  holdersWithoutDecision: { ran: boolean; count: number | null } | null;
  readError: string | null;
}

export const CAMPAIGN_TYPE_LABEL: Record<CampaignTypeKey, string> = {
  contributario: "Contributários",
};

export async function fetchContractLifecycle(workspaceId: string): Promise<IContractLifecycle> {
  const response = await api.get(`/v2/workspaces/${workspaceId}/lifecycle`);
  return response.data.data as IContractLifecycle;
}

export async function fetchConclusionCheck(workspaceId: string): Promise<IConclusionCheck> {
  const response = await api.get(`/v2/workspaces/${workspaceId}/lifecycle/conclusion-check`);
  return response.data.data as IConclusionCheck;
}

export async function concludeImplantation(workspaceId: string, reason: string): Promise<IContractLifecycle> {
  const response = await api.post(`/v2/workspaces/${workspaceId}/lifecycle/conclude`, { reason });
  return response.data.data as IContractLifecycle;
}

export async function reopenImplantation(workspaceId: string, reason: string): Promise<IContractLifecycle> {
  const response = await api.post(`/v2/workspaces/${workspaceId}/lifecycle/reopen`, { reason });
  return response.data.data as IContractLifecycle;
}
